import { render, staticRenderFns } from "./AddPackagePage.vue?vue&type=template&id=461776f4"
import script from "./AddPackagePage.vue?vue&type=script&lang=js"
export * from "./AddPackagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports